import * as React           from 'react';
import { useSearchParams }  from 'react-router-dom';

const useQueryParam = (param: string): string => {
    const [params, setParams] = useSearchParams();
    
    const value = React.useMemo(() => params.get(param) ?? '', [params, param]);

    React.useEffect(() => {
        if (params.get(param)) {
            const newParams = new URLSearchParams(params);
            newParams.delete(param);
            setParams(newParams);
        }
    }, [params, param, setParams]);

    return value;
};

export default useQueryParam;